import { cn } from "@/utils/cn";

interface TypeBadgeProps {
  type: "place" | "vehicle";
}

const TypeBadge = ({ type }: TypeBadgeProps) => (
  <span
    className={cn(
      "shrink-0 rounded px-1.5 py-0.5 text-[10px] font-bold",
      type === "place"
        ? "bg-blue-100 text-blue-600"
        : "bg-green-100 text-green-600",
    )}
  >
    {type === "place" ? "장소" : "차량"}
  </span>
);

export default TypeBadge;
